import React, { useEffect, useState } from 'react';
export function Clock() {
  const [time, setTime] = useState(new Date());
  useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);
  // LGS sınavı tarihi: 14 Haziran 2026
  const examDate = new Date('2026-06-14');
  const difference = examDate.getTime() - time.getTime();
  const days = Math.floor(difference / (1000 * 60 * 60 * 24));
  const hours = Math.floor(difference % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
  return <div className="flex flex-col items-center space-y-2" data-id="element-182">
      <div className="text-4xl sm:text-6xl font-bold text-white font-mono tracking-wider" data-id="element-183">
        {time.toLocaleTimeString('tr-TR', {
        hour: '2-digit',
        minute: '2-digit'
      })}
      </div>
      <div className="text-gray-400 text-center flex flex-col sm:block" data-id="element-184">
        <span data-id="element-185">
          {time.toLocaleDateString('tr-TR', {
          weekday: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
        </span>
        <span className="text-purple-400 mt-1 sm:mt-0 sm:ml-2" data-id="element-186">
          (LGS'ye {days} gün {hours} saat)
        </span>
      </div>
    </div>;
}